export default ({ request }) => ({
  ecomAmzFtyNoticeOutListApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/notice/out/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyNoticeOutDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/notice/out/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyNoticeOutSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/notice/out/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyNoticeOutDelApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/notice/out/del',
      method: 'POST',
      data,
    })
  },

  ecomAmzFtyNoticeOutSendWarehouseApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/notice/out/sendWarehouse',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyNoticeOutConfirmCarrierApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/notice/out/confirmCarrier',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyNoticeOutAdjustApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/notice/out/adjust',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyNoticeOutDetailListApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/notice/out/detail/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyNoticeOutDocListApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/notice/out/doc/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyNoticeOutCopyApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/notice/out/copy',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyNoticeOutCheckNoticeInApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/notice/out/check/notice/in',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyNoticeOutCancelApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/notice/out/cancel',
      method: 'POST',
      data,
    })
  },

  ecomAmzFtyNoticeOutDocReadBoxNoApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/notice/out/doc/readBoxNo',
      method: 'POST',
      data,
      timeout: 1000 * 60 * 5,
    })
  },
  ecomAmzFtyNoticeOutDetailSetBoxNoApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/notice/out/detail/setBoxNo',
      method: 'POST',
      data,
    })
  },
})
